/**
 * Summary
 * This component is a container for the Map UI elements. It will sit
 * above the map, but below Sidebar. Modals and Event Popup will display
 * in this layer. All clicks on the component background will be ignored,
 * however children will still be responsive to interaction.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { useApp } from '../_contexts';

import {
  // GlobalSearch,
  ChronicleTitle,
  ChronicleControls,
  Popup,
  ChronicleToolbar,
} from './';

export function UIContainer(props) {
  const { editMode } = useApp();
  const { data: chronicle } = useSelector((state) => state.chronicle);
  const { details: world } = useSelector((state) => state.world);
  // const { toggleSidebar } = props;
  // console.log(chronicle)
  // console.log(details)

  return (
    <div className="chronos-uiLayer-container">
      <ChronicleTitle world={world} chronicle={chronicle} />
      {chronicle && chronicle.setupComplete && <ChronicleControls />}
      {editMode && chronicle && chronicle.setupComplete && <ChronicleToolbar />}
      <Popup
        icon="fas fa-home"
        title="Event Name"
        description="lorem ipsum"
        // open={true}
      />
    </div>
  );
}
